// alterado - revisado

import {
    pesquisaList,
} from '../../../business-rules/List/ListService'

import {
    incrementaContFamiliar,
} from '../cadastro-form/CadastroServiceFamiliares'



export const processaRegistrosDefaultIniciaisHistoricoSaudeFamiliares = ( values, familiar ) => {

    if (familiar) {
        if (!values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares) {
            values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares = []
        }

        if (!values.historicoSaudeFamiliares) {
            values.historicoSaudeFamiliares = []
        }
        
        if (!pesquisaList(values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares, familiar).id) {

            values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares.push(
                {
                    id: familiar
                }
            )

            incrementaContFamiliar(values)
            values.historicoSaudeFamiliares.push({
                familiar: familiar,
                familiarHistoricoSaudeFamiliares: values.contFamiliar,
            })
        }
    }
}



export const calculaHistoricoSaudeFamiliaresCondicaoSaude = ( item ) => {
    if (item.vivo !== "S") {
        item.idadeFamiliar = ''
    }
}

export const calculaHistoricoSaudeFamiliaresSaudeObito = ( item ) => {
    if (item.vivo !== "N") {
        item.idadeObito = ''
        item.causaObito = ''
    }
}

export const processaAlteracaoHistoricoSaudeFamiliaresVivo = ( item ) => {
    calculaHistoricoSaudeFamiliaresCondicaoSaude(item)
    calculaHistoricoSaudeFamiliaresSaudeObito(item)
}